import React from 'react'
import classNames from 'classnames'
import { string, bool, func } from 'prop-types'

const ToggleSwitch = ({
  name,
  checked,
  label,
  onValueChange
}) => {
  const checkboxClasses = classNames('afd-toggle-input', { 'checked': checked })
  return (
    <div className='nft-field'>
      <div className='afd-toggle-switch afd-toggle-switch--small'>
        <input className={checkboxClasses}
          data-insights-funnel-step={name}
          id={`toggle-${name}`}
          type='checkbox'
          defaultChecked={checked} />
        <label className='afd-toggle-slider' htmlFor={`toggle-${name}`} onClick={onValueChange} />
      </div>
      {label && <span className='afd-toggle-bold'>{label}</span>}
    </div>
  )
}

ToggleSwitch.propTypes = {
  name: string,
  checked: bool,
  label: string,
  onValueChange: func.isRequired
}

export default ToggleSwitch